import KendoGrid from '../KendoGrid'
import KendoGridColumn from '../KendoGridColumn'
import KendoGridToolbar from '../KendoGridToolbar'

let KendoGridInstaller = class {
    static install(Vue) {
        Vue.component(KendoGrid.name, KendoGrid)
        Vue.component(KendoGridColumn.name, KendoGridColumn)
        Vue.component(KendoGridToolbar.name, KendoGridToolbar)
    }
}

export default KendoGridInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoGridInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/kendo-grid-installer/index.js